import { render, staticRenderFns } from "./CreateVisitors.vue?vue&type=template&id=23f62ac6&"
import script from "./CreateVisitors.vue?vue&type=script&lang=js&"
export * from "./CreateVisitors.vue?vue&type=script&lang=js&"
import style0 from "./CreateVisitors.vue?vue&type=style&index=0&id=23f62ac6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports